<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useClickOutside } from "#/utils/useClickOutside";

const isShowDropDown = ref(false);
const isInitialized = ref(false);
const { vClickOutside } = useClickOutside();

const closeMenu = () => {
  isShowDropDown.value = false;
};

const toggleDropdown = (event: MouseEvent) => {
  event.stopPropagation();
  isShowDropDown.value = !isShowDropDown.value;
};

onMounted(() => (isInitialized.value = true));
</script>

<template>
  <div class="actions-wrapper">
    <span
      class="dd-toggle dropdown-toggle color-primary"
      @click="toggleDropdown"
    >
      <slot name="toggle">•••</slot>
    </span>

    <div
      v-click-outside="closeMenu"
      :class="[
        'actions-list',
        { 'actions-list--visible': isShowDropDown && isInitialized },
      ]"
    >
      <slot>
        <div class="actions-list__item">
          <i class="raberu-icon-stairs color-primary"></i>
          <span>Пункт 1</span>
        </div>

        <div class="actions-list__item color-third">
          <i class="raberu-icon-folder"></i>
          <span>Пункт 2</span>
        </div>
      </slot>
    </div>
  </div>
</template>

<style lang="scss">
.actions-wrapper {
  position: relative;

  .dd-toggle {
    font-size: 16px;
    cursor: pointer;
  }

  .actions-list {
    width: fit-content;
    padding: 10px 12px;
    position: absolute;
    box-sizing: border-box;
    right: -15px;
    top: 23px;
    border: 1px var(--border-color) solid;
    background: white;
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.4);
    border-radius: 10px;
    z-index: 1;
    text-align: left;
    opacity: 0;
    transform: translateY(-10px);
    transition:
      opacity 0.3s ease,
      transform 0.3s ease;
    pointer-events: none;

    &--visible {
      opacity: 1;
      transform: translateY(0);
      pointer-events: auto;
    }

    &__item {
      margin-bottom: 8px;
      display: flex;
      align-items: center;

      &:hover {
        span {
          text-decoration: underline;
          cursor: pointer;
        }
      }

      i {
        margin-right: 7px;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
